module.exports = __webpack_public_path__ + "static/img/team-fs-01.1f653e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team-fs-01.jpg
// module id = kSI2
// module chunks = 1